// import React, { useState } from "react";
// import axios from "axios";

// const CreateClassModal = ({ show, closeModal, admin }) => {
//   const [className, setClassName] = useState("");
//   const [section, setSection] = useState("");
//   const [description, setDescription] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [alert, setAlert] = useState({ message: "", type: "" });

//   if (!show) return null;

//   const handleCreateClass = async () => {
//     if (!className || !section) {
//       setAlert({ message: "Class Name and Section are required", type: "danger" });
//       return;
//     }

//     setLoading(true);
//     setAlert({ message: "", type: "" });

//     try {
//       const response = await axios.post("https://api.scannscore.com/class", {
//         class_name: className,
//         section,
//         description,
//         user_id: admin.id
//       });

//       if(response.status == 200){
//       setAlert({ message: "Class added successfully!", type: "success" });
//       setClassName("");
//       setSection("");
//       setDescription("");

//       setTimeout(() => closeModal(), 1500);
//       }
//     } catch (err) {
//       console.error(err);
//       setAlert({ message: err.response?.data?.message || "Failed to add class", type: "danger" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={overlay}>
//       <div style={modal}>
//         {/* Header with Close Button */}
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <h3 style={{ margin: "15px" }}>Create New Class</h3>
//           <button
//             onClick={closeModal}
//             style={{ border: "none", background: "transparent", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
//           >
//             ✕
//           </button>
//         </div>

//         {/* Alert */}
//         {alert.message && (
//           <div className={`alert alert-${alert.type}`} role="alert">
//             {alert.message}
//           </div>
//         )}

//         {/* Inputs */}
//         <div style={{ marginBottom: "16px" }}>
//           <label htmlFor="className" style={{ display: "block", marginBottom: "3px", fontWeight: "bold" }}>
//             Class Name
//           </label>
//           <input
//             id="className"
//             placeholder="eg. Science Batch 2025"
            
//             style={input}
//             value={className}
//             onChange={(e) => setClassName(e.target.value)}
//           />
//         </div>

//         <div style={{ marginBottom: "16px" }}>
//           <label htmlFor="section" style={{ display: "block", marginBottom: "4px", fontWeight: "bold" }}>
//             Section / Group
//           </label>
//           <input
//             id="section"
//             placeholder="eg. A,B or Evening"
//             style={input}
//             value={section}
//             onChange={(e) => setSection(e.target.value)}
//           />
//         </div>

//         <div style={{ marginBottom: "16px" }}>
//           <label htmlFor="description" style={{ display: "block", marginBottom: "4px", fontWeight: "bold" }}>
//             Description
//           </label>
//           <textarea
//             id="description"
//             placeholder="optional details"
//             style={textarea}
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}



            
//           />
//         </div>

//         {/* Create Button */}
//         <button style={btn} onClick={handleCreateClass} disabled={loading}>
//           {loading ? "Creating..." : "Create Class"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CreateClassModal;

// // Overlay Styles
// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.3)",
//   backdropFilter: "blur(6px)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   zIndex: 999,
// };

// // Modal Styles
// const modal = {
//   background: "#fff",
//   padding: "30px",
//   borderRadius: "10px",
//   width: "400px",
//   boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
// };

// // Input Styles
// const input = {
//   width: "100%",
//   padding: "10px",
//   marginTop: "10px",
//   border: "1px solid #ccc",
//   borderRadius: "6px",
//   fontSize: "14px",
//   boxSizing: "border-box",
// };

// // Textarea Style
// const textarea = {
//   ...input,
//   height: "80px",
//   resize: "none",
// };


// const btn = {
//   width: "100%",
//   marginTop: "15px",
//   padding: "10px",
//   background: "#2F49cF",
//   color: "#fff",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
//   fontSize: "16px",
// };
// CreateClassModal.js
import React, { useState, useEffect } from "react";
import axios from "axios";


const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.3)",
  backdropFilter: "blur(6px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const modal = {
  background: "#fff",
  padding: "30px",
  borderRadius: "10px",
  width: "400px",
  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
};

const input = {
  width: "100%",
  padding: "10px",
  marginTop: "10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "14px",
  boxSizing: "border-box",
};

const textarea = {
  ...input,
  height: "80px",
  resize: "none",
};

const btn = {
  width: "100%",
  marginTop: "15px",
  padding: "10px",
  background: "#2F49cF",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "16px",
};



const CreateClassModal = ({ show, closeModal, admin, classData }) => {
  const [className, setClassName] = useState("");
  const [section, setSection] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });


  useEffect(() => {
    if (classData) {
      setClassName(classData.class_name || "");
      setSection(classData.section || "");
      setDescription(classData.description || "");
    } else {
      setClassName("");
      setSection("");
      setDescription("");
    }
  }, [classData]);

  if (!show) return null;



  const handleSubmit = async () => {
    if (!className || !section) {
      setAlert({ message: "Class Name and Section are required", type: "danger" });
      return;
    }

    setLoading(true);
    setAlert({ message: "", type: "" });

    try {
      let response;
      if (classData && classData.id) {
      
        response = await axios.put(`https://api.scannscore.com/update-class/${classData.id}`, {
          class_name: className,
          section,
          description,
          user_id: admin.id,
        });
      } else {
    
        response = await axios.post("https://api.scannscore.com/class", {
          class_name: className,
          section,
          description,
          user_id: admin.id,
        });
      }

      if (response.status === 200) {
        setAlert({ message: classData ? "Class updated successfully!" : "Class added successfully!", type: "success" });
        setTimeout(() => closeModal(), 1500);
      }
    } catch (err) {
      console.error(err);
      setAlert({ message: err.response?.data?.message || "Failed to submit class", type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: "15px" }}>{classData ? "Edit Class" : "Create New Class"}</h3>
          <button
            onClick={closeModal}
            style={{ border: "none", background: "transparent", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
          >
            ✕
          </button>
        </div>

    
        {alert.message && (
          <div className={`alert alert-${alert.type}`} role="alert">
            {alert.message}
          </div>
        )}

  
        <div style={{ marginBottom: "16px" }}>
          <label htmlFor="className" style={{ display: "block", marginBottom: "3px", fontWeight: "bold" }}>
            Class Name
          </label>
          <input
            id="className"
            placeholder="eg. Science Batch 2025"
            style={input}
            value={className}
            onChange={(e) => setClassName(e.target.value)}
          />
        </div>


        <div style={{ marginBottom: "16px" }}>
          <label htmlFor="section" style={{ display: "block", marginBottom: "4px", fontWeight: "bold" }}>
            Section / Group
          </label>
          <input
            id="section"
            placeholder="eg. A,B or Evening"
            style={input}
            value={section}
            onChange={(e) => setSection(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label htmlFor="description" style={{ display: "block", marginBottom: "4px", fontWeight: "bold" }}>
            Description
          </label>
          <textarea
            id="description"
            placeholder="optional details"
            style={textarea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

   
        <button style={btn} onClick={handleSubmit} disabled={loading}>
          {loading ? (classData ? "Updating..." : "Creating...") : classData ? "Update Class" : "Create Class"}
        </button>
      </div>
    </div>
  );
};

export default CreateClassModal;